<p-dialog header="Multi Update" [modal]="true" [(visible)]="showMultiUpdate" [style]="{ width: '25rem' }">
    <span class="p-text-secondary block mb-3">
        Update multiple accounts.
        <button
            pButton
            pRipple
            severity="info"
            text
            aria-label="Clear Bulk Updates"
            #clearBulkUpdates
            label="Clear"
            (click)="clearBulk()"
        >
        </button>
    </span>

    <form [formGroup]="updateFormGroup" #updateForm="ngForm" id="bulkUpdate">
        <p-floatLabel variant="on" class="mb-3">
            <p-select styleClass="w-full" *ngIf="expenseTypes as items"
                [options]="items" formControlName="expenseType" [filter]="true" appendTo="body"></p-select>
            <label for="float-dd">Expense Type</label>
        </p-floatLabel>
        <p-floatLabel variant="on" *ngIf="showCostCenters">
            <p-select styleClass="w-full" *ngIf="costCenters as items" [options]="items" formControlName="costCenter" [filter]="true"
                appendTo="body"></p-select>
            <label for="float-dd">Cost Center</label>
        </p-floatLabel>
    </form>

    <ng-template #footer>
        <button #applyBulk pButton pRipple text type="button" severity="success" aria-label="Apply Bulk Updates"
            [disabled]="!selected?.length || updateFormGroup.invalid" label="Update" (click)="applyBulkUpdate(); clearBulk();"></button>
    </ng-template>
</p-dialog>

<p-toolbar>

    <div class="flex items-center">
        <p-checkbox binary="true" [(ngModel)]="showNA" (ngModelChange)="updateFilter()"></p-checkbox>
        <label class="ml-2">Include Not Applicable</label>
    </div>
    <p-message *ngIf="showCostCenters" severity="info"
        text="To update multiple accounts, select/check the accounts, click 'Update Multiple Accounts', then assign a type and cost center and click update."></p-message>
    <p-message *ngIf="showCostCenters == false" severity="info"
        text="To update multiple accounts, select/check the accounts, click 'Update Multiple Accounts', then assign a type and click update."></p-message>
    <button pButton pRipple severity="primary" label="Update Multiple Accounts" (click)="this.showMultiUpdate = true; clearBulk();"></button>
</p-toolbar>

<p-table stripedRows #dataTable
    [value]="filteredItems"
    dataKey="Accountlistid"
    editMode="row"
    [scrollable]="true"
    scrollHeight="50vh"
    [style]="{ 'min-width': '100%' }"
    [(selection)]="selected"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td
                [attr.colspan]="costCenters?.length < 2 ? 7 : 8"
                style="text-align: center"
            >
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item>
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Selection -->
            <th class="select-cell">
                <p-tableHeaderCheckbox *ngIf="!editing"></p-tableHeaderCheckbox>
            </th>
            <!-- Account -->
            <th pSortableColumn="Accountcode">
                Account
                <p-sortIcon
                    pSortableColumn="Accountcode"
                    field="Accountcode"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Accountcode" display="menu" class="ml-auto" />
            </th>
            <!-- Account Type -->
            <th pSortableColumn="Accounttype">
                Account Type
                <p-sortIcon
                    pSortableColumn="Accounttype"
                    field="Accounttype"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Accounttype" display="menu" class="ml-auto" />
            </th>
            <!-- Expense Type -->
            <th pSortableColumn="Calctype">
                Expense Type
                <p-sortIcon
                    pSortableColumn="Calctype"
                    field="Calctype"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="Calctype" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            defaultLabel="Filter"
                            #ddlExpenseTypeFilter
                            maxSelectedLabels="1"
                            appendTo="body"
                            [options]="expenseTypes"
                            [filter]="true"
                            [ngModel]="selectedExpenseTypes"
                            styleClass="w-full"
                            [ngModel]="value"
                            (ngModelChange)="filter($event)"
                        ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Cost Center -->
            <th [hidden]="costCenters?.length < 2">
                Cost Center
                <p-columnFilter field="Costcenterid" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            defaultLabel="Filter"
                            maxSelectedLabels="1"
                            appendTo="body"
                            [options]="costCenters"
                            [filter]="true"
                            styleClass="w-full"
                            [ngModel]="value"
                            (ngModelChange)="filter($event)"
                        ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Modified Date -->
            <th pSortableColumn="Modifieddate">
                Modified Date
                <p-sortIcon
                    pSortableColumn="Modifieddate"
                    field="Modifieddate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-item
        let-edit="editing"
        let-ri="rowIndex"
        let-rowData
    >
        <tr
            [pSelectableRow]="item"
            [pEditableRow]="item"
            [ngClass]="{
                'ui-editing-row':
                    edit && editing?.Accountlistid === rowData?.Accountlistid
            }"
            data-id="row-{{ item.Accountlistid }}"
        >
            <!-- Edit -->
            <td class="edit-cell">
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item.id !== 'add' &&
                        selected?.length < 2
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onRowEditInit(item)"
                    title="Edit"
                ></button>
                <button
                    title="Save"
                    *ngIf="edit"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    title="Cancel"
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Selection -->
            <td class="select-cell">
                <p-tableCheckbox
                    *ngIf="!editing"
                    [value]="rowData"
                ></p-tableCheckbox>
            </td>
            <!-- Account -->
            <td class="disabled">
                {{ item?.Accountcode }}
            </td>
            <!-- Account Type -->
            <td class="disabled">
                {{ item?.Accounttype }}
            </td>
            <!-- Expense Type -->
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <div>
                            <ef-dropdown [items]="expenseTypes" [rowData]="item" property="Calctype"></ef-dropdown>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <div
                            data-toggle="tooltip"
                            data-placement="top"
                            [attr.title]="
                                (
                                    expenseTypes
                                    | itemlookup: 'value':item?.Calctype
                                )?.label
                            "
                        >
                            {{
                                (
                                    expenseTypes
                                    | itemlookup: 'value':item?.Calctype
                                )?.label
                            }}
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Cost Center -->
            <td [hidden]="costCenters?.length < 2">
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <div>
                            <ef-dropdown [items]="costCenters" [rowData]="item" property="Costcenterid"></ef-dropdown>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <div
                            data-toggle="tooltip"
                            data-placement="top"
                            [attr.title]="
                                (
                                    costCenters
                                    | itemlookup: 'value':item?.Costcenterid
                                )?.label
                            "
                        >
                            {{
                                (
                                    costCenters
                                    | itemlookup: 'value':item?.Costcenterid
                                )?.label
                            }}
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Modified Date -->
            <td class="disabled">
                {{
                    moment(item?.Modifieddate).isValid()
                        ? moment(item?.Modifieddate).format('MM/DD/YYYY')
                        : ''
                }}
            </td>
        </tr>
    </ng-template>
</p-table>
